import React from 'react';
import NotificationListFunctional from './components/notification-list-functional';

const NotificationList = () => {
	return <NotificationListFunctional />;
};

export default NotificationList;
